import { render, staticRenderFns } from "./RedirectErrorModal.vue?vue&type=template&id=9ed8aa9e"
import script from "./RedirectErrorModal.vue?vue&type=script&lang=js"
export * from "./RedirectErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports